import { Scope } from '@/domain/external-invitation/entities/external-invitation.entity';
import { Sector } from '@/domain/impact/impact.entity';

import { SCOPES } from './data/scopes';
import { Mode } from './scopes-types';

export function getScopesFromModeAndSector(
  mode: Mode,
  sector: Sector,
): Scope[] {
  const scopes: Scope[] = Object.values(SCOPES[mode][sector]);
  const uniqueScopes = [...new Set(scopes)];
  return uniqueScopes;
}
